const timeline = document.querySelector('.timeline');
/**
 * make sure we don't run this script if the timeline is not present
 */
if (timeline !== null) {

	(function () {
		// define variables
		var items = document.querySelectorAll('.in_viewer');

		/**
		 * check if an element is in viewport
		 * @param el - element argument
		 * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
		 */
		function isElementInViewport(el) {
			var rect = el.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		}

		function callbackFunc() {
			for (let i = 0; i < items.length; i++) {
				if (isElementInViewport(items[i])) {
					items[i].parentNode.classList.add("in-view");
				}
			}
		}

		// listen for events
		window.addEventListener('load', callbackFunc);
		window.addEventListener('resize', callbackFunc);
		window.addEventListener('scroll', callbackFunc);

	})();

	// When the user scrolls the page, execute myFunction 
	/* window.onscroll = function () {
		myFunction()
	};

	function myFunction() {
		var element = document.getElementById('timeline_links');
		var y = elment.scrollTop;
		alert('timeline' + y);
		document.getElementById('myBar').style.height = y + "px";
		 var winScroll = document.documentElement.scrollTop;
		var height = document.documentElement.scrollHeight - element.clientHeight;
		var scrolled = (winScroll / height) * 100;
		document.getElementById("myBar").style.height = scrolled + "%"; 
	} */

	var bar = document.getElementById('myBar');

	var element = document.getElementById('timeline_links');

	var topPos = element.getBoundingClientRect().top + window.scrollY;

	//console.log('timeline ul top Position = ' + topPos);

	/* window.onscroll = function () {
		scrollIndicator()
	}; */

	/* function scrollIndicator() {
		var winScroll = document.documentElement.scrollTop;
		var height = document.documentElement.clientHeight;
		var scrolled = 100;
		console.log('winScroll = ' + winScroll);
		console.log('height = ' + height);

		if (height > 0) {
			y_placement = (topPos - winScroll);
			//console.log('y placement =' + y_placement);

			//scrolled = (height / winScroll) * 100;
			scrolled = ((winScroll - 800) / height) * 100;
		}

		bar.style.height = scrolled + '%';
	} */
}
